import fetch from '../utils/fetch';
import { cashierUrl, solutionsUrl } from '../endpoints';
import RecognitionEverywhereSDK from '@nackle/recognition-everywhere-sdk';

export function RecService( companyId ) {
    const sdk = new RecognitionEverywhereSDK( { companyId, fetch } );

    const getMarketplaceItems = async ( personId, country ) => {
        return sdk.catalogService.getMenuItems( { id: personId, counrty: country } );
    };

    return { getMarketplaceItems };
}

function RecognitionService() {
    const sdk = new RecognitionEverywhereSDK( { companyId: '', fetch } );

    const createRecognition = async ( recognition )  => {
        return sdk.recognitionService.createRecognition( recognition );
    };

    const searchParticipants = async ( searchText, filters )  => {
        return sdk.rosterService.genericSearchPersons( { searchText, personProperties: [ 'emails', 'attributes', 'nodes' ] } );
    };

    const getPersonDetail = async ( personId ) => {
        const personProperties = [ 'nodes' ];
        return sdk.rosterService.getPersonDetailed( personId, personProperties );
    };

    const searchProgramsAndRewardChoices = async ( filters ) => {
        return sdk.recognitionService.searchProgramsAndRewardChoices( filters );
    };

    const getMarketplaceItems = async ( personId, country ) => {
        return sdk.catalogService.getMenuItems( { id: personId, counrty: country } );
    };

    const getPoints = async ( personId ) => {
        return fetch( `${ cashierUrl }/account/id/${ encodeURIComponent( personId ) }/point-balance` );
    };

    const getMediaLabel = async () => {
        return fetch( `${ solutionsUrl }/solutions` );
    };

    const getMerchUrl = async ( personId ) => {
        const merchandiseBody = JSON.stringify( {
            landingPage: 'merchandiseLanding',
            browseOnly: false
        } );

        const headers = {  [ 'Content-Type' ]: 'application/json' };

        return fetch( `${ cashierUrl }/account/id/${ encodeURIComponent( personId ) }/catalog-sso`, 
            { headers, method: 'POST', body: merchandiseBody }
        );
    };

    const getExpUrl = async ( personId ) => {
        const experiencesBody = JSON.stringify( {
            landingPage: 'experiencesMarketplace',
            browseOnly: false
        } );

        const headers = {  [ 'Content-Type' ]: 'application/json' };

        return fetch( `${ cashierUrl }/account/id/${ encodeURIComponent( personId ) }/catalog-sso`, 
            { headers, method: 'POST', body: experiencesBody }
        );
    };

    return {
        createRecognition,
        searchParticipants,
        getExpUrl,
        getPersonDetail,
        getMarketplaceItems,
        getMediaLabel,
        getMerchUrl,
        getPoints,
        searchProgramsAndRewardChoices
    };
}

export default new RecognitionService();
